import api from "../config";
import URLS from "../../constants/urls";
export const _getNodesBySiteAndFloor = async (siteId, floorId, pageNumber = 0, pageSize = 10) => {
    const response = await api.get(`${URLS.NODE}/${siteId}/${floorId}`, { params: { pageNumber, pageSize } });
    return response.data;
};
export const _updateNodeProperties = async (siteId, floorId, nodeId, data) => {
    const response = await api.put(`${URLS.NODE}/${siteId}/${floorId}/${nodeId}`, data);
    return response.data;
};
export const _updateNode = async (siteId, nodeId, data) => {
    const response = await api.put(`${URLS.NODE}/update/${siteId}/${nodeId}`, data);
    return response.data;
};
